import { getMenuState, setMenuMuteState } from '../app-state/state.menu'
import { setVideoMuteState } from '../app-state/state.video'
import { VideoType } from '../constants/enums'
import { MODALSTATE } from '../state/modals'
import { openModelMenuDialog } from '../state/modals/state.dialog'
import { initVideo } from '../state/state.video'
import { safeObj } from '../utilities/safe'
import {
    TransitionTypes,
    motionTransition,
    type TransitionType,
} from '../utilities/transitions'
import { loadUserIfNeeded } from './loadUserIfNeeded'

const onMenuMute = (isMuted: boolean) => {
    const {
        persist: { mute },
    } = getMenuState()

    if (isMuted === mute) {
        return
    }

    if (mute === undefined) {
        setVideoMuteState(isMuted)
        return
    }

    setMenuMuteState(undefined)
}

export const openMenuDialog = async (
    slugOrId: string | number,
    props: {
        hideNextPrev?: boolean
        message?: boolean
        noVideo?: boolean
        room?: boolean
        transitionSource?: TransitionType
    } = {},
) => {
    const user = await loadUserIfNeeded(slugOrId)
    const { noVideo, transitionSource } = props
    const {
        isAway,
        isModel,
        isClubShow,
        isGroupShow,
        isPrivateShow,
        isTruePrivate,
        isBroadcasting,
        streamType,
        slug,
        id,
    } = safeObj(user)

    motionTransition(
        () => {
            const {
                persist: { mute },
            } = getMenuState()
            if (isModel === false) {
                openModelMenuDialog(slug, props)
                return
            }

            const inShow = streamType !== 'public'
            const hiddenShow =
                (isTruePrivate ||
                    isPrivateShow ||
                    isGroupShow ||
                    isClubShow ||
                    isAway) &&
                !inShow

            if (!noVideo && isBroadcasting && !hiddenShow) {
                initVideo(slug, {
                    videoType: VideoType.Menu,
                    onMute: onMenuMute,
                    mute,
                })
            }
            openModelMenuDialog(slug, props)
        },
        {
            id,
            skipTransition: MODALSTATE.dialog.show,
            transitionSource,
            transitionDestination: TransitionTypes.MENU,
        },
    )
}
